import React, { useState } from 'react'
import UserDetails from 'containers/UserDetails'
import { ContainerGeral } from './Styled'

// Componentes
import BannerPrincipal from './Components/BannerPrincipal/BannerPrincipal'
import ItensInclusos from './Components/ItensInclusos/ItensInclusos'
import Depoimentos  from './Components/Depoimentos/Depoimentos'
import TextoFinal from './Components/TextoFinal/TextoFinal'

export default function PromocaoTJSP () {

	return (
		<UserDetails showSpinner>
			{details => {

				const [data] = useState(details.blackfriday)

				let planosInitial = data.planos;

				return (
					<ContainerGeral padding={false}>
						
						{/* Banner Principal */}
						<BannerPrincipal planos={planosInitial} desconto={planosInitial[1].assinaturas[0].boleto.desconto_valor} />

						{/* Itens Inclusos */}
						<ItensInclusos planos={planosInitial[0].assinaturas[0]} />

						{/* Depoimentos */}
						<Depoimentos />

						{/* Texto Final */}
						<TextoFinal />
	
					</ContainerGeral>
				)
				
			}}
		</UserDetails>
	)
}
